import EventManager from "./event_manager";
import AudioManager from "./audio_manager";
import invitationCountdownManager from './invitationCountdown_manager';
import AppData from "../pacakge/public/const/app_data";
import GameUtil from "../utility/game_util";
import { GameManager } from "./game_manager";

const { ccclass } = cc._decorator;

enum TimeType {
    INTERVAL,
    COUNT_DOWN
}


@ccclass
export default class TimeManager extends cc.Component {

    _needCheckModule: string[] = [
        "LoginModule",
        "Hall",
        "Match",
        "GoldEntranceModule"
    ]

    public static readonly instance: TimeManager = new TimeManager();
    backGround = false

    private _handles = []
    private _serverMarkTime: number = 0     //服务器初始化时间，毫秒
    private _serverLocalDifTime: number = 0 //服务器初始化时和本地相差时间，毫秒
    private _lastTime = 0

    private _hideTime = 0//切后台的时间
    private _showTime = 0//切到前台的时间


    private _backTarget = ""//切到后台前标记，切回前台后使用

    m_maxId: number = 0
    m_callbackMap = {}

    AppRunningTime = 0

    start() {
        cc.game.on(cc.game.EVENT_HIDE, this.onApplicationHide.bind(this))
        cc.game.on(cc.game.EVENT_SHOW, this.onApplicationShow.bind(this))
    }

    setBackTarget(value: string) {
        TimeManager.instance._backTarget = value
    }

    getBackTarget() {
        return TimeManager.instance._backTarget
    }




    private onApplicationHide() {
        TimeManager.instance._hideTime = Date.now()
        cc.log("切到后台了！", TimeManager.instance._hideTime)
        this.backGround = true
        if (CC_JSB) {
            // AudioManager.instance.pauseMusic()//必须释放掉声音，不然微信中切到前台会自动播放缓存的声音
            // AudioManager.instance.pauseAllSound()
        }

        EventManager.instance.dispatch("game_event_show", false)
    }

    private onApplicationShow() {
        TimeManager.instance._showTime = Date.now()
        let difTime = TimeManager.instance._showTime - TimeManager.instance._hideTime
        cc.log("切到前台了！", TimeManager.instance._showTime, difTime)
        this.backGround = false
        EventManager.instance.dispatch("game_event_show", true, difTime, TimeManager.instance._backTarget)
        if (CC_JSB) {
            // AudioManager.instance.startMusic()
            // AudioManager.instance.resumeAllSound()
        }
        this.setInvitationInterval(difTime);
        GameManager.updateVersionInHallScene()
    }

    //轮询 name为key值 每个interval调用一次callback count是执行次数不传或0都是无限次
    setInerval(name: string, callback: Function, target: any, interval: number, count?: number) {
        let index = this.hasHander(name, callback, TimeType.INTERVAL)
        if (index > 0) {
            TimeManager.instance._handles[index].remove = true
        }
        let data = {
            type: TimeType.INTERVAL,
            name: name,
            callback: callback,
            target: target,
            interval: interval,//间隔
            totalCount: count ? count : 0,//interval执行总次数
            curCount: 0,//当前执行了多少次
            progress: 0,//每执行一次 进度每秒加1
            remove: false,
            step: (nowTime) => {
                data.progress++
                if (data.progress >= data.interval) {//可以执行一次了
                    data.progress = 0
                    data.curCount++
                    let callback: Function = data.callback
                    callback.call(data.target, data.curCount)
                    if (data.curCount >= data.totalCount && data.totalCount) {//所有interval已经完成
                        data.remove = true
                    }
                }
            }
        }
        TimeManager.instance._handles.push(data)
    }

    //倒计时 name 为key值 间隔interval秒后调用callback
    countDown(name: string, callback: Function, target: any, interval: number) {
        let now = new Date().getTime()
        let index = this.hasHander(name, callback)
        if (index > 0) {
            TimeManager.instance._handles[index].remove = true
        }
        let data = {
            type: TimeType.COUNT_DOWN,
            name: name,
            callback: callback,
            target: target,
            targetTime: now + interval * 1000,
            remove: false,
            step: (nowTime) => {
                if (data.targetTime <= nowTime && data.remove == false && data.target) {
                    let callback: Function = data.callback
                    callback.call(data.target)
                    data.remove = true
                }
            }
        }
        TimeManager.instance._handles.push(data)
    }

    //倒计时 name 为key值  到targetTime时调用callback
    countDownTargetTime(name: string, callback: Function, target: any, targetTime: number) {
        let index = this.hasHander(name, callback)
        if (index >= 0) {
            TimeManager.instance._handles[index].remove = true
        }
        let data = {
            type: TimeType.COUNT_DOWN,
            name: name,
            callback: callback,
            target: target,
            targetTime: targetTime,
            remove: false,
            step: (nowTime) => {
                if (data.targetTime <= nowTime && data.remove == false && data.target) {
                    let callback: Function = data.callback
                    callback.call(data.target)
                    data.remove = true
                }
            }
        }
        TimeManager.instance._handles.push(data)
    }

    offAllByKey(name: string) {
        let length = TimeManager.instance._handles.length
        for (let i = 0; i < length; i++) {
            let data = TimeManager.instance._handles[i]
            if (data.name == name) {
                TimeManager.instance._handles[i].remove = true
            }
        }
    }

    offCountDown(name: string, callback: Function) {
        this.offHander(name, callback, TimeType.COUNT_DOWN)
    }

    offInterval(name: string, callback: Function) {
        this.offHander(name, callback, TimeType.INTERVAL)
    }

    private offHander(name: string, callback: Function, type = TimeType.COUNT_DOWN) {
        let index = this.hasHander(name, callback, type)
        if (index >= 0) {
            TimeManager.instance._handles[index].remove = true
        }
    }

    private hasHander(name: string, callback: Function, type = TimeType.COUNT_DOWN) {
        let length = TimeManager.instance._handles.length
        for (let i = 0; i < length; i++) {
            let data = TimeManager.instance._handles[i]
            if (data.type == type && data.callback == callback && data.name == name) {
                return i
            }
        }
        return -1
    }

    //初始化服务器时间
    initServerTime() {
        if (this._serverMarkTime > 0) {
            return
        }

        let requestData: IHttpRequestData = {
            baseUrl: AppData.apiHttpUrl + "getTime",
        }
        let self = this
        GameUtil.http_get(requestData, function (res) {
            self._serverMarkTime = res.data / 1000
            self._serverLocalDifTime = Math.floor(new Date().getTime() / 1000) - self._serverMarkTime
        }, function (errorData) {})
    }

    //没有初始化得到的是本地时间
    getServerTime() {
        let nowTime = Math.floor(new Date().getTime() / 1000)
        return nowTime - this._serverLocalDifTime
    }

    //TimeManager每秒执行一次 所有TimeManager中的方法都是以秒为精确的 可能有1秒内误差
    private step() {
        let nowTime = this.getServerTime()
        for (let i = 0; i < TimeManager.instance._handles.length; i++) {
            let data = TimeManager.instance._handles[i]
            if (!data.remove && data.target) {
                data.step(nowTime)
            } else {
                TimeManager.instance._handles.splice(i, 1)
                i--
            }
        }
    }


    update(dt) {//切到后台不执行和cc.schedule一样
        TimeManager.instance.AppRunningTime += dt
        // let now = Date.now()
        // if (this._lastTime == 0 || this._lastTime + 1000 < now) {
        //     this._lastTime = now
        //     this.step()
        //     this.checkBlack()
        // }
    }

    private genId() {
        return ++this.m_maxId
    }

    doSchedule(callback: Function, interval?: number, repeat?: number, delay?: number) {
        let self = this
        let id = this.genId()
        let tmpFun = function () {
            if (!repeat) {
                self.cancelSchedule(id)
            }
            callback()
        }
        this.m_callbackMap[Number(id)] = tmpFun
        this.schedule(tmpFun, interval, repeat, delay)
        return id
    }

    doScheduleOnce(callback: Function, delay: number): number {
        let self = this
        let id = this.genId()
        let tmpFun = function () {
            this.m_callbackMap[id.toString()] = null
            callback()
        }
        this.m_callbackMap[Number(id)] = tmpFun
        this.scheduleOnce(tmpFun, delay)
        return id
    }

    cancelSchedule(id: number) {
        let key = id.toString()
        let callback = this.m_callbackMap[key]
        if (callback) {
            this.unschedule(callback)
            this.m_callbackMap[key] = null
        }
    }

    cleanDoShedules() {
        let object = this.m_callbackMap
        let list = []
        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                list.push(key)
            }
        }
        for (let i = 0; i < list.length; i++) {
            const key = list[i];
            this.cancelSchedule(Number(key))
        }
        this.m_callbackMap = {}
    }

    getTimeLeft2BySecond(s:number): string {
        let hours = Math.round((s - 30 * 60) / (60 * 60));
        let minutes = Math.round((s - 30) / 60) % 60;
        let seconds = s % 60;
        let hoursStr = (hours > 0 ? ((hours > 9 ? hours: "0"+  hours) + ":") : "00:")
        let minutesStr = (minutes > 0 ? ((minutes > 9 ? minutes : "0"+  minutes) + ":") : "00:")
        let secondsStr = (seconds > 0 ? ((seconds > 9 ? seconds: "0"+  seconds) + " ") : "00")
        return hoursStr + minutesStr + secondsStr
    }
    setInvitationInterval(interval:number)
    {
        //cc.log("invitationCountdownManager:",interval);
        invitationCountdownManager.instance.setInterval(interval/1000);
    }
}